module.exports = __webpack_public_path__ + "static/img/head-guang.fd20315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head-guang.png
// module id = JBi8
// module chunks = 1